import { ScrollTextIcon } from 'lucide-react';
import { use } from 'react';

import { ReleaseNotesOpenerCtx } from './release-notes-opener';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

/** "What's new" in the user menu: every release, newest first, whenever the reader wants it. */
export function ReleaseNotesMenuItem() {
  const openReleaseNotes = use(ReleaseNotesOpenerCtx);
  if (openReleaseNotes === null) return null;
  return (
    <DropdownMenuItem onClick={openReleaseNotes}>
      <ScrollTextIcon data-icon="inline-start" />
      What’s new
    </DropdownMenuItem>
  );
}
